// extracted by mini-css-extract-plugin
module.exports = {"col":"OpponentFilter_col_3hGvj"};